import axios from 'axios'
// import { fromAxiosError } from './errorHandling' // 暫時註解，未使用
import { FrontendErrorService } from '../services/errorService'
import { storage } from './storage'
import { getApiBaseUrl } from '../config/env'

// 從環境變數獲取 API URL（已驗證）
const API_BASE_URL = getApiBaseUrl()

// 建立 axios 實例
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000, // 增加超時時間
  headers: {
    'Content-Type': 'application/json',
  },
})

// 請求攔截器 - 添加 JWT token
api.interceptors.request.use(
  (config) => {
    const token = storage.getItem('accessToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 響應攔截器 - 處理 token 刷新和錯誤轉換
api.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const originalRequest = error.config

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        const refreshToken = storage.getItem('refreshToken')
        if (refreshToken) {
          const response = await axios.post('/api/auth/refresh', {
            refreshToken,
          })

          const { accessToken, refreshToken: newRefreshToken } = response.data
          storage.setItem('accessToken', accessToken)
          storage.setItem('refreshToken', newRefreshToken)

          // 重試原始請求
          originalRequest.headers.Authorization = `Bearer ${accessToken}`
          return api(originalRequest)
        }
      } catch (_refreshError) {
        // 刷新失敗，清除 token 並重定向到登入頁
        storage.removeItem('accessToken')
        storage.removeItem('refreshToken')
        window.location.href = '/login'
      }
    }

    // 使用新的錯誤處理服務
    const frontendError = FrontendErrorService.handleApiError(error)
    FrontendErrorService.logError(error, {
      apiCall: originalRequest?.url,
      method: originalRequest?.method
    })

    return Promise.reject(frontendError)
  }
)

export default api